module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-regular-372d0cc3288fe8e97df49742baefce90.ttf";